import { render, staticRenderFns } from "./ScanPage.vue?vue&type=template&id=6682e256"
import script from "./ScanPage.vue?vue&type=script&lang=js"
export * from "./ScanPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports